export const ALL_ITEMS_PAGE_SIZE = 9999;
